module.exports = __webpack_public_path__ + "static/media/icn_instagram.47d5f278.svg";